<template>
  <div class="row m-t-xs">
    <div class="col-xs-12 col-sm-6">
      {{ charge.description }}
    </div>
    <div class="col-xs-4 col-sm-2" v-if="isPerTonneCharge || isSingleCharge">
    </div>
    <div class="col-xs-4 col-sm-2"  v-if="isPerTonneCharge">
      {{ costPerTonne }}
    </div>
    <div class="col-xs-4 col-sm-2"  v-if="isSingleCharge">
      {{ charge.total_excluding_gst | money }}
    </div>
    <div class="col-xs-4 col-sm-2 amount text-right">
      {{ cost }}
    </div>
  </div>
</template>
<script>
  import accounting from 'accounting'

  export default {
    props: ['charge'],

    computed: {
      costPerTonne () {
        return `${accounting.formatMoney(this.charge.per_unit_cost)}/t`
      },

      cost () {
        return accounting.formatMoney(this.charge.per_unit_cost * this.charge.quantity)
      },

      isPerTonneCharge () {
        return this.charge.type === 'charge_per_tonne'
      },

      isSingleCharge () {
        return this.charge.type === 'charge_single'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ShowPaymentItemCharge.vue?0f4e9454